(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.glow.component.module-clc-approval-form.provider.clc-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../../../../api/async')
    ])
    .provider('ClcApi', clcApiProvider)

  function clcApiProvider () {
    return {
      $get: clcApiService
    }
  }

  clcApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function clcApiService (SdkConfig, ThismomentAsyncApi) {
    var getClcContentAPI = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/source/v1/get-clc-content')
    var clcRequestAPI = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/source/v1/closed-loop-confirmation-message/:id')

    return {
      getClcContent: getClcContentAPI.get,
      sendClcMessage: clcRequestAPI.post,
      updateClcRequest: clcRequestAPI.update
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-clc-approval-form/provider/clc-api.js